/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type getRecentHistory_user = {
    readonly recentHistoryList: ReadonlyArray<{
        readonly eventDate: string | null;
        readonly item: {
            readonly contemporaryTrackingString: string;
            readonly firstPhotoWebPath: string | null;
            readonly pdpURL: string | null;
            readonly title: string | null;
            readonly browseUrl: string | null;
            readonly categoryCode: string | null;
            readonly serviceId: string | null;
            readonly categoryPath: string | null;
            readonly seller: {
                readonly serviceId: string | null;
            } | null;
        } | null;
    } | null> | null;
    readonly " $refType": "getRecentHistory_user";
};
export type getRecentHistory_user$data = getRecentHistory_user;
export type getRecentHistory_user$key = {
    readonly " $data"?: getRecentHistory_user$data;
    readonly " $fragmentRefs": FragmentRefs<"getRecentHistory_user">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "getRecentHistory_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "recentHistoryList",
      "storageKey": null,
      "args": null,
      "concreteType": "RecentHistoryItem",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "eventDate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "item",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "contemporaryTrackingString",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "firstPhotoWebPath",
              "args": [
                {
                  "kind": "Literal",
                  "name": "size",
                  "value": "small"
                }
              ],
              "storageKey": "firstPhotoWebPath(size:\"small\")"
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "pdpURL",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "browseUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "categoryCode",
              "args": null,
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "categoryPath",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "seller",
              "storageKey": null,
              "args": null,
              "concreteType": "Seller",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'b9b6124e5daf6af0fb66f29cb325281b';
export default node;
